import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf99f668"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("导入表格")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("颜色含义")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean grayRow" }, "发票没有", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean blueRow" }, "金额不一致", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean yellowRow" }, "匹配成功", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean greenRow" }, "状态为空", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("认证")

import {ref, Ref, reactive, computed, onMounted } from 'vue'
import { ElMessage, ElMessageBox, rowProps } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, formatTime, exportHandle } from '@/utils/index'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { statusFilter, invoiceType } = PaymentModuleUtils
const {
  'POST/invoice/conditions': fetchList,
  // 发票管理_详情查询
  'POST/invoice/detail': invoiceDetailApi,
  // 发票认证
  'PATCH/invoice/confirm_invoice': confirm_invoiceApi,
  // 公司列表
  'GET/company': companyListApi,
  'GET/pay_pool/drop_list':dropListApi,
  'GET/organizations':organizationsListApi,
  // 导出
  'POST/invoice/invoice_download': downloadApi,
  // 表格导入
  'POST/invoice/invoice_upload':invoiceUploadApi,
  // 获取费用类别
  'GET/invoice_expense_categorys/tree': categorysTreeApi,
} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)
const defaultTbData = computed(() => {
  return MI_tableData.value.map(e => {
    e.childInvoiceList && e.childInvoiceList.map((_child: any, index: number) => {
      _child._id = _child.id
      _child.id = _child.id + index.toString()
    })
    return e
  })
})
const companyList=ref([])
const organizationsList:any=ref([])
// let categoryOption: any = ref([])
// let categoryItemOption: any = ref([])
const categoryList = reactive([
  {
    category: '长期经营资产购置',
    matter: [
      {label: "经营办公物业购置"},
      {label: "经营办公设施、设备及器具购置"},
      {label: "信息系统购置"},
      {label: "装修/修缮工程"},
    ]
  },
  {
    category: '对外投资项目',
    matter: [
      {label: "投资理财", },
      {label: "对外投资设立（分）子公司", },
      {label: "企业并购"},
    ]
  },
  {
    category: '采购商品/接受劳务',
    matter: [
      {label: "经营用水电气/物管/租金"},
      {label: "译员劳务购买"},
      {label: "软件/技术服务"},
      {label: "其他"},
    ]
  },
  {
    category: "日常业务经费",
    matter: [
      {label:"公务接待费" },
      {label:"车辆运行及市内交通费" },
      {label:"差旅费" },
      {label:"培训费/会议费" },
      {label:"其他"},
      {label:"办公用品费" },
      {label:"招聘费"},
    ]
  },
  {
    category: "备用金借支",
    matter: [
      {label: "个人借款" },
      {label: "公务借款"},
    ]
  },
  {
    category: "市场推广专项经费",
    matter: [
      {label: "专项业务活动费"},
      {label: "广告宣传费（含设计费/宣传品）"},
      {label: "其他"},
      {label: "软件/技术服务"},
    ]
  },
  {
    category: "职工薪酬",
    matter: [
      {label: "员工福利"},
      {label: "绩效奖励"},
      {label: "团建费"},
      {label: "业务提成"},
      {label: "工资、五险一金"},
    ]
  },
  {
    category: "知识产权费",
    matter: [
      {label: "商标费"},
      {label: "著作权费"},
      {label: "专利费"},
      {label: "资质费"},
      {label: "其他IP费"},
    ]
  },
  {
    category: "销售退款",
    matter: [
      {label: "境内客户", },
      {label: "境外客户"},
    ]
  },
  {
    category: "税款-tax fee",
    matter: [
      {label: "税款"},
    ]
  },
  {
    category: "偿还贷款",
    matter: [
      {label: "短期借款偿还", },
      {label: "长期借款偿还"},
    ]
  },
  {
    category: "校企合作费用",
    matter: [
      {label: "差旅费", },
      {label: "校企接待费",},
      {label: "活动经费"},
    ]
  },
])
const metterList: any = ref([])
const categoryChange = (data: string) => {
  metterList.value = categoryList.find(el => el.category === data)?.matter ?? []
}
const searchConfig = ref([
  {
    label: "CO单号",
    value: '',
    upKey: 'no',
    props: { clearable : true }
  },
  {
    label: "发票号码",
    value: '',
    upKey: 'invoiceNo',
    props: { clearable : true }
  },
  {
    label: "发票日期",
    type: "TIME",
    value: '',
    upKey: 'invoiceDate',
    upProps: {includeKey: 'invoiceDateRange'},
    props: { clearable : true, type: 'daterange' }
  },
  {
    type: 'SELECT',
    label: '发票类型',
    value: '',
    upKey: 'invoiceType',
    options: [
      {label: '普票', id: 'OR'},
      {label: '专票', id: 'SP'},
      {label: '无票', id: 'NO'},
      {label: '确认无票', id: 'CONFIRM_NO'},
      {label: '单据', id: 'BILL'},
      {label: '共享专票', id: 'SH_SP'},
      {label: '共享普票', id: 'SH_OR'},
      { label: '电子发票-专票', id: 'EI_SP'},
      { label: '电子发票-普票', id: 'EI_OR'},
    ],
    props: {clearable: true, placeholder: '请选择发票类型',},
    seleProps: { }
  },
  {
    type: 'SELECT',
    label: '公司',
    value: '',
    upKey: 'companyId',
    options: companyList,
    props: {clearable: true, placeholder: '请选择公司',},    
    seleProps: {label: 'name', valueName: 'id',}
  },
  {
    type: 'SELECT',
    label: '归属部门',
    value: '',
    upKey: 'departmentName',
    options: organizationsList,
    props: {clearable: true, placeholder: '请选择归属部门',},    
    seleProps: {label:"name", valueName:"name"}
  },
  {
    label: "发起人",
    value: '',
    upKey: 'creator',
    props: { clearable : true }
  },
  {
    type: "TIME",
    label: "认证日期",
    value: '',
    upKey: 'taxDate',
    upProps: {
      includeKey: 'taxBureauInvoiceDateRange'
    },
    props: {type: 'daterange'}
  },
  {
    type: "TIME",
    label: "支付时间",
    value: '',
    upKey: 'payDate',
    upProps: {
      includeKey: 'payDateRange'
    },
    props: {type: 'daterange'}
  },
  {
    type: "TIME",
    label: "创建时间",
    value: '',
    upKey: 'createDate',
    upProps: {
      includeKey: 'createDateRange'
    },
    props: {type: 'daterange'}
  },
  {
    type: 'SELECT',
    label: '费用类别',
    value: '',
    upKey: 'category',
    options: categoryList,
    selectCb: categoryChange,
    props: {clearable: true, placeholder: '请选择费用类别'},
    seleProps: {label: 'category', valueName: 'category'}
  },
  {
    type: 'SELECT',
    label: '费用事项',
    value: '',
    upKey: 'matter',
    options: metterList,
    props: {clearable: true, placeholder: '请选择费用事项'},
    seleProps: {label: 'label', valueName: 'label'}

  },
])
onMounted(()=>{
  companyListApi().then((res:any)=>companyList.value=res)
  organizationsListApi().then((res:any)=>organizationsList.value=res)
  // 获取费用类别
  /* categorysTreeApi().then(rep => {
    categoryItemOption.value = []
    categoryOption.value = rep.map((e: any) => {
      e.label = e.number + ' ' + e.name
      if(e.children){
        categoryItemOption.value.push(...e.children.map((e: any) => {
          e.label = e.number + ' ' + e.name
          return e
        }))
      }
      return e
    })
  }) */
})
const searchHandle = (params: any) => {
  // 无参数： 0；有参数： 1
  let _extra = { hasParam: 0}
  if(Object.values(params).find(e => e) !== undefined){
    _extra = { hasParam: 1 }
  } else {
    _extra = { hasParam: 0 }
  }
  fetchData({
    query: {
      ...params,
      ..._extra
    }
  })
}
// 认证
const authFg = ref<boolean>(false)
const authConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: '',
    upKey: 'certifiedAt',
    props: {
      'value-format': 'YYYY-MM-DD'
    },
    rule: [{ required: true, message: '请选择日期', trigger: 'change' }]
  },
])
const authHandle = (row: any) => {
  MI_modifyForm({}, authConfig, authFg, async (params: any) => {
    await confirm_invoiceApi({...params, id: row.id}, { contentType: 'formData'})
    ElMessage.success('认证成功')
    authFg.value = false
    fetchData(MI_params)
    
  })
  // confirm_invoiceApi()
}


// 添加
const addConfig = ref([])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {})
  ElMessage.success('成功')
  addFg.value = false
  fetchData(MI_params)
}

// 修改
const modifyFg = ref<boolean>(false)
const modifyHandle = (row: any) => { }

// 删除
const delHandle = (row: any) => { }

// 导出
const exportSearchHandle = () => {
  ElMessageBox.alert('是否导出搜索结果', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    return exportHandle(downloadApi, MI_params.query)
  }).then(() => {
    ElMessage.success('成功')
  }).catch(() => {
    ElMessage.error('导出失败')

  })
}
// 导入表格
const uploadMethod=({file}:any)=>{
    // console.log(file)
  let formdata=new FormData()
  formdata.append('file',file)
  invoiceUploadApi(formdata).then((res:any)=>{
    ElMessageBox.confirm(res,{showCancelButton:false,confirmButtonText:"确定"})
  })
}

// ----------------
const rowColorFormat = ({row}: {row: AuthorityRow}) => {
  if(row.matchStatus === '发票没有'){
    return 'grayRow'
  }
  if(row.matchStatus === '金额不一致'){
    return 'blueRow'
  }
  if(row.matchStatus === '匹配成功'){
    return 'yellowRow'
  }
  if(!row.matchStatus){
    return 'greenRow'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_space, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (exportSearchHandle())),
          class: "mt-10 mb-10"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_el_upload, {
          "show-file-list": false,
          "http-request": uploadMethod
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_popover, {
          placement: "bottom",
          width: 400,
          trigger: "hover"
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, { type: "info" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(defaultTbData),
      "row-key": "id",
      "row-class-name": rowColorFormat,
      "tree-props": { children: 'childInvoiceList', },
      "max-height": _unref(MI_height) - 80 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "CO单号",
          prop: "no",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "发起人",
          prop: "creator",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "company",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "费用归属部门",
          prop: "department",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "费用类型",
          prop: "reimburseType",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "发票类型",
          prop: "invoiceType",
          width: "110",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(_unref(invoiceType)(row.invoiceType as any)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "发票代码",
          prop: "invoiceCode",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "发票号码",
          prop: "invoiceNo",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "发票日期",
          prop: "invoiceDate",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "摘要",
          prop: "summary",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "费用类别",
          "show-overflow-tooltip": "",
          prop: "category",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          label: "费用事项",
          "show-overflow-tooltip": "",
          prop: "matter",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          label: "认证日期",
          prop: "certificationDate",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "认证金额",
          prop: "certifiedAmount",
          width: "110",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "认证税额",
          prop: "certifiedTaxAmount",
          width: "110",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "总金额",
          prop: "totalAmount",
          width: "110",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "税率",
          prop: "taxRate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "税额",
          prop: "taxAmount",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "不含税金额",
          prop: "taxExcluded",
          width: "110",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "进项税额",
          prop: "inputTaxAmount",
          width: "110",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "支付费用",
          prop: "amount",
          width: "110",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "余额",
          prop: "invoiceBalance",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "支付时间",
          prop: "payAt",
          width: "110",
          "show-overflow-tooltip": "",
          formatter: _unref(formatTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "创建时间",
          prop: "createAt",
          width: "110",
          "show-overflow-tooltip": "",
          formatter: _unref(formatTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "发票状态",
          prop: "matchStatus",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "审批状态",
          prop: "approvedStatus",
          width: "110",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(_unref(statusFilter)(row.approvedStatus)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "urgent",
          width: "130",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: 'right'
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  onClick: _withModifiers(($event: any) => (authHandle(row)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      "page-sizes": [30, 50, 100, 500 ],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: authFg.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((authFg).value = $event)),
      title: "认证",
      width: "500px"
    }, {
      default: _withCtx(() => [
        (authFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: authConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})